/*!
 * Roundway Funnel Quiz config — Wellgard-energy re-skin (forest/cream/gold).
 * Step-by-step flow with icon-circle goal grid + pill answers + "ANSWER FOR
 * X% OFF" banners. Tag-vector scoring preserved end-to-end.
 */
(function () {
  'use strict';
  window.RoundwayQuizConfigs = window.RoundwayQuizConfigs || {};

  // ---------- On-brand line icons (forest stroke, apothecary feel) ----------
  var SVG_ATTR = 'viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  function svg(path) { return '<svg ' + SVG_ATTR + '>' + path + '</svg>'; }
  var ICON = {
    female: svg('<circle cx="16" cy="13" r="6"/><path d="M16 19v9M12 25h8"/>'),
    male: svg('<circle cx="13" cy="19" r="6"/><path d="M17.5 14.5 24 8m0 0h-5m5 0v5"/>'),
    neutral: svg('<circle cx="16" cy="16" r="1.6"/>'),
    energy: svg('<path d="M17 5 8 18h7l-1 9 9-13h-7l1-9Z"/>'),
    gut: svg('<path d="M20 4c-1 3 1 4 2 6s1 5-2 6-5 1-5 4 3 4 3 6-2 3-4 2"/><path d="M11 9c-3 1-4 4-3 7s4 3 4 6-2 4-1 6"/><circle cx="20" cy="4" r="1"/><circle cx="11" cy="9" r="1"/>'),
    sleep: svg('<path d="M23 19a8 8 0 1 1-10-10 7 7 0 0 0 10 10Z"/>'),
    immunity: svg('<path d="M16 5 7 8v7c0 6 4 10 9 12 5-2 9-6 9-12V8l-9-3Z"/><path d="m12 16 3 3 5-6"/>'),
    skin: svg('<path d="M16 5v4M16 23v4M5 16h4M23 16h4M9 9l2.5 2.5M20.5 20.5 23 23M9 23l2.5-2.5M20.5 11.5 23 9"/><circle cx="16" cy="16" r="3.5"/>'),
    hormones: svg('<circle cx="16" cy="16" r="4"/><path d="M16 12V6M16 26v-6M12 16H6M26 16h-6M11 11 7 7M25 25l-4-4M11 21l-4 4M25 7l-4 4"/>'),
    stress: svg('<path d="M8 22a8 8 0 1 1 16 0"/><path d="M16 22V9M11 12l5-3 5 3"/>'),
    general: svg('<path d="M5 14a6 6 0 0 1 11-3 6 6 0 0 1 11 3c0 7-11 13-11 13S5 21 5 14Z"/>'),
    glp1: svg('<path d="m6 26 5-5M9 23l3 3M11 21l10-10 3 3L14 24l-3-3Z"/><path d="m20 8 4 4M22 6l4 4"/>'),
    leaf: svg('<path d="M26 6c-12 0-18 6-18 14 0 4 2 6 2 6S26 22 26 6Z"/><path d="M8 26 20 12"/>'),
    pill: svg('<rect x="5" y="13" width="22" height="6" rx="3" transform="rotate(-30 16 16)"/><path d="m11 21 10-10"/>'),
    plane: svg('<path d="M4 18 28 8l-4 18-6-6-8 4 2-6-8-2Z"/>'),
    training: svg('<path d="M4 13v6M28 13v6M7 11v10M25 11v10M10 16h12"/>'),
    wine: svg('<path d="M10 5h12l-1 7a5 5 0 0 1-10 0L10 5Z"/><path d="M16 17v8M12 27h8"/>'),
    kids: svg('<circle cx="16" cy="11" r="4"/><path d="M8 27c1-5 4-8 8-8s7 3 8 8"/><circle cx="13" cy="11" r=".6"/><circle cx="19" cy="11" r=".6"/>'),
    sunrise: svg('<path d="M4 23h24M8 23a8 8 0 0 1 16 0M16 9V4M9 12 6 9M23 12l3-3"/>'),
    sun: svg('<circle cx="16" cy="16" r="5"/><path d="M16 4v3M16 25v3M4 16h3M25 16h3M8 8l2 2M22 22l2 2M8 24l2-2M22 10l2-2"/>'),
    sunset: svg('<path d="M4 23h24M8 23a8 8 0 0 1 16 0M16 4v5M9 12 6 9M23 12l3-3M2 27h28"/>'),
    moon: svg('<path d="M23 19a8 8 0 1 1-10-10 7 7 0 0 0 10 10Z"/>'),
    carrot: svg('<path d="M9 23 22 10l-3-3L6 20l3 3Z"/><path d="M22 10c2-2 5-2 5-2s0 3-2 5M19 7c-1-2 0-4 0-4s3 1 3 3"/><path d="m11 18 2 2M14 15l2 2"/>'),
    seed: svg('<path d="M16 26c0-8 4-12 10-12-1 8-5 12-10 12Z"/><path d="M16 26c0-8-4-12-10-12 1 8 5 12 10 12ZM16 26V14"/>'),
    check: svg('<path d="m7 17 6 6L25 9"/>'),
    heart: svg('<path d="M16 27S5 20 5 13a6 6 0 0 1 11-3 6 6 0 0 1 11 3c0 7-11 14-11 14Z"/><path d="m9 15h4l2-3 2 6 2-3h4"/>'),
    circulation: svg('<path d="M16 4c4 4 6 7 6 10a6 6 0 0 1-12 0c0-3 2-6 6-10Z"/><path d="M13 15a3 3 0 0 0 3 3"/><path d="M8 26h16"/>'),
    sugar: svg('<rect x="6" y="12" width="20" height="9" rx="2" transform="rotate(-12 16 16)"/><path d="m11 14 3 5M17 12l3 5"/>'),
    fibre: svg('<path d="M6 9c6 0 6 14 12 14s6-14 8-14"/><path d="M6 17c6 0 6 8 12 8"/>'),
    lungs: svg('<path d="M16 4v12"/><path d="M13 12c0-3-6-2-7 3s-1 9 2 9 4-3 4-6Z"/><path d="M19 12c0-3 6-2 7 3s1 9-2 9-4-3-4-6Z"/>'),
    mens: svg('<circle cx="13" cy="19" r="6"/><path d="M17.5 14.5 24 8m0 0h-5m5 0v5"/>'),
    womens: svg('<circle cx="16" cy="12" r="6"/><path d="M16 18v9M12 24h8"/>'),
    urinary: svg('<path d="M16 5c4 5 7 8 7 12a7 7 0 0 1-14 0c0-4 3-7 7-12Z"/>'),
    mood: svg('<circle cx="16" cy="16" r="11"/><path d="M11 19c1.5 2 8 2 10 0"/><circle cx="12" cy="13" r=".8"/><circle cx="20" cy="13" r=".8"/>'),
  };




  window.RoundwayQuizConfigs['funnel'] = {
    product: 'funnel',
    variant: 'v3-wellgard',
    theme: 'wellgard',
    eyebrow: 'Roundway · 60-second match',
    captureEmail: true,
    delayMs: 2500,
    defaultCode: 'n10',
    rewardPct: '10%',
    defaultUrl: '/collections/all',
    tagVector: true,
    productsKey: 'RoundwayQuizProducts',
    handleMapKey: 'RoundwayQuizHandleMap',
    story: {
      eyebrow: 'Roundway · 60-second match',
      title: "Answer 3 questions for an _exclusive discount_ tailored to your needs",
      sub: "One personalised stack, built around your goals, with a code in your inbox.",
      foot: 'Trusted by 120,000+ customers',
      teaser: 'Take the quiz, unlock an exclusive discount tailored to you.',
    },

    questions: [
      // ---------- Q1: PRIMARY GOAL (circles, single) ----------
      {
        id: 'goal',
        title: 'What is your #1 most important health goal?',
        hint: 'Pick the one that matters most right now.',
        banner: true,
        layout: 'circles',
        multi: false,
        options: [
          { v: 'energy',   label: 'More Energy',      icon: ICON.energy,   weights: { energy: 3, liver: 1 } },
          { v: 'gut',      label: 'Better Digestion', icon: ICON.gut,      weights: { gut: 3 } },
          { v: 'sleep',    label: 'Better Sleep',     icon: ICON.sleep,    weights: { sleep: 3, stress: 1 } },
          { v: 'immunity', label: 'Stronger Immunity',icon: ICON.immunity, weights: { immunity: 3, recovery: 2 } },
          { v: 'skin',     label: 'Healthy Skin',     icon: ICON.skin,     weights: { skin: 3, liver: 1 } },
          { v: 'hormones', label: 'Hormonal Balance', icon: ICON.hormones, weights: { hormones: 3, skin: 1 } },
          { v: 'stress',   label: 'Less Stress',      icon: ICON.stress,   weights: { stress: 3, sleep: 1, mood: 1 } },
          { v: 'heart',    label: 'Heart & Circulation', icon: ICON.heart, weights: { heart: 3, circulation: 2 } },
          { v: 'sugar',    label: 'Blood Sugar',      icon: ICON.sugar,    weights: { 'blood-sugar': 3, glp1: 1 } },
          { v: 'liver',    label: 'Liver Support',    icon: ICON.leaf,     weights: { liver: 3, energy: 1 } },
          { v: 'general',  label: 'General Wellbeing',icon: ICON.general,  weights: { 'daily-maintain': 3 } },

        ],
      },

      // ---------- Q2: SECONDARY GOALS (multi) ----------
      {
        id: 'modifiers',
        title: "Anything else you'd like to support?",
        hint: 'Pick any that apply, or skip.',
        layout: 'circles',
        multi: true,
        options: [
          { v: 'glp1',        label: 'GLP-1 Support',     icon: ICON.glp1,     weights: { glp1: 3, gut: 1, 'daily-maintain': 1 } },
          { v: 'post_cleanse',label: 'Post Cleanse',      icon: ICON.leaf,     weights: { 'post-cleanse': 3, reseed: 2 } },
          { v: 'post_abx',    label: 'After Antibiotics', icon: ICON.pill,     weights: { reseed: 3, 'post-cleanse': 1 } },
          { v: 'travel',      label: 'Travel Often',      icon: ICON.plane,    weights: { cleanse: 3, gut: 2, immunity: 1 } },
          { v: 'training',    label: 'Train Hard',        icon: ICON.training, weights: { recovery: 2, 'daily-maintain': 1 } },
          { v: 'drinks',      label: 'Drink Most Nights', icon: ICON.wine,     weights: { drinker: 3, liver: 2 } },
          { v: 'kids',        label: 'For The Kids',      icon: ICON.kids,     weights: { kids: 4, immunity: 2 } },
          { v: 'mens',        label: "Men's Health",      icon: ICON.mens,     weights: { mens: 3, urinary: 1 } },
          { v: 'womens',      label: "Women's Health",    icon: ICON.womens,   weights: { womens: 3, hormones: 2 } },
          { v: 'fibre',       label: 'More Fibre',        icon: ICON.fibre,    weights: { fibre: 3, gut: 1 } },
          { v: 'none',        label: 'None Of These',     icon: ICON.neutral,  weights: {} },

        ],
      },

      // ---------- Q3: SYMPTOMS / PROBLEMS (multi) ----------
      {
        id: 'symptoms',
        title: 'Which of these sound familiar?',
        hint: 'Pick any that apply, or skip.',
        layout: 'circles',
        multi: true,
        options: [
          { v: 'bloating',     label: 'Bloating After Meals',  icon: ICON.gut,      weights: { gut: 3, cleanse: 1 } },
          { v: 'irregular',    label: 'Irregular Bowels',      icon: ICON.gut,      weights: { gut: 3, reseed: 1 } },
          { v: 'low_energy',   label: 'Afternoon Crashes',     icon: ICON.energy,   weights: { energy: 3, liver: 1 } },
          { v: 'poor_sleep',   label: 'Wired But Tired',       icon: ICON.sleep,    weights: { sleep: 3, stress: 2 } },
          { v: 'breakouts',    label: 'Skin Breakouts',        icon: ICON.skin,     weights: { skin: 3, liver: 2, gut: 1 } },
          { v: 'sick_often',   label: 'Get Sick Easily',       icon: ICON.immunity, weights: { immunity: 3, reseed: 1 } },
          { v: 'brain_fog',    label: 'Brain Fog',             icon: ICON.stress,   weights: { liver: 2, energy: 1, gut: 1 } },
          { v: 'sugar_crave',  label: 'Sugar Cravings',        icon: ICON.sugar,    weights: { 'blood-sugar': 3, glp1: 1, gut: 1 } },
          { v: 'cold_hands',   label: 'Cold Hands & Feet',     icon: ICON.circulation, weights: { circulation: 3, heart: 2 } },
          { v: 'chesty',       label: 'Chest & Airways',       icon: ICON.lungs,    weights: { respiratory: 3, immunity: 1 } },
          { v: 'low_mood',     label: 'Flat Mood',             icon: ICON.mood,     weights: { mood: 3, stress: 2 } },
          { v: 'bladder',      label: 'Bladder & Flow',        icon: ICON.urinary,  weights: { urinary: 3, mens: 1 } },
          { v: 'none',         label: 'None Of These',         icon: ICON.neutral,  weights: {} },

        ],
      },

    ],
  };
})();

